import { EntityTypes } from '../../utilities/Constants';
import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useNoteCategoryTypes = (entityType?: EntityTypes) => {
    const { zoneApiClient } = useZoneContext();
    return useQuery({
        queryKey: ['get-note-category-types', entityType ?? 'all'],
        queryFn: async () => {
            const response = await zoneApiClient.getNoteCategoryTypesByEntityType(entityType);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve note category types.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        cacheTime: 60 * 60 * 100,
        staleTime: 60 * 60 * 100,
    });
};
